<div class="flex flex-col px-2 mx-2">
	<div class="w-full flex justify-between mt-2">
		<app-requisition-status-dropdown
			class="w-2/3"
			(statusChange)="onStatusChange($event)"
			[status]="requisition?.status"
		></app-requisition-status-dropdown>
		<div class="flex items-end">
			<app-button
				*ngIf="!open"
				btn="tertiary"
				[icon]="ICON.DOWN"
				size="small"
				(click)="toggleOpen()"
				[testHook]="testHooks.ShowDetailsButton"
				>Show details</app-button
			>
			<app-button
				*ngIf="open"
				btn="tertiary"
				[icon]="ICON.UP"
				size="small"
				(click)="toggleOpen()"
				[testHook]="testHooks.HideDetailsButton"
				>Hide details</app-button
			>
		</div>
	</div>
	<div
		class="mt-2"
		*ngIf="requisition?.status === requisitionStatuses.ACCEPT_UNDERTAKING"
	>
		<div class="flex">
			<app-checkbox
				class="my-2"
				label="Fulfilled"
				[ngModel]="requisition?.fulfilled"
				(ngModelChange)="onFulfilledChange($event)"
				[testHook]="testHooks.FulfilledCheckbox"
			></app-checkbox>
		</div>

		<div class="flex mt-2 items-end" *ngIf="requisition?.fulfilled">
			<app-input
				class="mr-2"
				label="Discharged by instrument number"
				[ngModel]="requisition?.dischargedInstrumentNumber"
				(debounce)="onDischargedInstrumentNumberChange($event)"
				[testHook]="testHooks.DischargedByInstrumentNumber"
			></app-input>
			<app-date-picker
				class="ml-2"
				label="Registered on date"
				[ngModel]="requisition?.registeredOnDate"
				(ngModelChange)="onRegisteredOnDateChange($event)"
				[testHook]="testHooks.RegisteredOnDateDatePicker"
			></app-date-picker>
		</div>
	</div>
	<div *ngIf="open" class="mt-4 grid grid-cols-2 gap-4" [@openClose]>
		<div *ngFor="let field of requisition?.fields | keyvalue">
			<label class="font-bold">{{ field.value.label }}</label>
			<p>
				{{
					field.value.type === valueTypes.AMOUNT
						? (field.value.value | centsToDollars)
						: field.value.value
				}}
			</p>
		</div>

		<div class="row-span-2 col-span-2">
			<label class="font-bold">Full text of requisition</label>
			<p [innerHTML]="requisitionParsedText"></p>
		</div>
	</div>
</div>
